# New Asset Help

## <v-icon>mdi-video-wireless</v-icon> Live Stream

### Name

A descriptive name for this Live Stream.

### URL

URL for the live stream (supported types TBA).

**Note:** Currently we expect a username and password. Use root:root if there isn't one.

**IP Address:** http://username:password@XXX.XXX.XXX.XXX/example/filename.ext

**FQDN:** http://username:password@myexamplewebsite.com/example/filename.ext

## <v-icon>mdi-video-input-hdmi</v-icon> Video Feed

### Name

A descriptive name for this Video Feed.

### Input

This is as per your Ventuz Input. For your first input, use `1`, for your second: `2` etc.

## <v-icon>mdi-access-point-network</v-icon> NDI

Note: CanvasPro automatically picks up the NDI connections. However, if you're expecting one to appear in future; you can add it here so you can start using it in CanvasPro Scenes and Queues.

### Name

A descriptive name for this NDI

### Input

This will be the NDI Connection Name. Normally `PC-NAME (NDI NAME)`
